/** Admin: import customers for an owner (OwnerScopeProvider twin). */
import React from 'react';
import { useLocalSearchParams } from 'expo-router';
import { OwnerScopeProvider } from '../../../../../src/context/OwnerScopeContext';
import CustomerImportScreen from '../../../../../src/screens/CustomerImportScreen';
export default function AdminOwnerCustomerImport() {
  const { id } = useLocalSearchParams<{ id: string }>();
  return <OwnerScopeProvider ownerId={id ?? null}><CustomerImportScreen /></OwnerScopeProvider>;
}
